<template>
  <div class="quicklink" style="margin: 20px 0 0px">
    <div class="titleBox">
      <div class="title">开展项目</div>
    </div>
    <div class="quick-bot">
      <div
        class="single-link"
        v-for="(item, index) in quickLinkList"
        :key="index"
        @click="NotLike(item)"
      >
        <div class="link-box" v-if="item.href != ''">
          <img :src="item.icon" />
          <h3>{{ item.title }}</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      quickLinkList: [
        // {
        //   href: "/professionals",
        //   type: "router",
        //   icon: "&#xe601;",
        //   title: "住房和城乡建设领域施工现场专业人员"
        // },
        // {
        //   href: "http://jxjggs.urdt.cn",
        //   type: "http",
        //   icon: "&#xe876;",
        //   title: "培训机构承诺公示平台"
        // },
        {
          href: "/threetype",
          type: "router",
          icon: require("@/assets/img/peixun.png"),
          title: "安管人员培训平台",
        },
        // {
        //   // href: "/threetype",
        //   icon: "&#xe619;",
        //   title: "建筑工人职业培训考核"
        // },
        // {
        //   href: "/comingsoon",
        //   icon: "&#xe634;",
        //   type: "router",
        //   title: "燃气从业人员系统"
        // },
        // {
        //   href: "/erjian",
        //   icon: "&#xe617;",
        //   type: "router",
        //   title: "注册师继续教育"
        // },
        // {
        //   // href: "/gongren",
        //   icon: "&#xe6db;",
        //   title: "数据修改管理系统"
        // },
        {
          href: "/gongren",
          type: "router",
          icon: require("@/assets/img/fangdichan.png"),
          title: "房地产估价师继续教育",
        },

        {
          href: "http://jxtzzy.zhujianpeixun.com/",
          icon: require("@/assets/img/tezhongzuoye.png"),
          type: "http",
          title: "特种作业从业人员初始培训",
        },
      ],
    };
  },
  methods: {
    NotLike(item) {
      if (!item.href) {
        this.$Message.warning("暂未开放");
      } else if (item.type == "http") {
        this.$parent.showView =false;
        window.open(item.href);
      } else if (item.type == "router") {
        this.$parent.showView =false;
        this.$router.push(item.href);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.quick-bot {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 30px;

  .single-link {
    width: 386px;
    height: 140px;
    background: #edf4fc;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 18px;
    color: #0c5fb8;

    .link-box {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      img {
        margin-bottom: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/quicklink.vue